import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {AppNotification} from 'app/models/app-notification.model';
import {HeadTraining} from 'app/models/head-readiness.model';
import {AdminService} from 'app/services/admin.service';

const CURRENT_HEAD_MESSAGE = 'CURRENT_HEAD_TRAINING_NOTIFICATION';
const HEAD_PREPARATION_TYPE = 'PREPARATION';
const HEAD_NOTIFICATION_CATEGORY = 'NOTIFICATION_GENERAL';
const HEAD_LEARNING_ROUTE = '/dashboard/learning';
const HEAD_GROUP_ROUTE = '/dashboard/groups/';
const HEAD_EMPTY_ROUTE = '';
const HEAD_EMPTY_COUNT = 0;

@Component({
  selector: 'app-head-notification',
  templateUrl: './head-notification.component.html',
  styleUrls: ['./head-notification.component.css']
})
export class HeadNotificationComponent implements OnChanges, OnDestroy {
  @Input() notification: AppNotification;
  private readonly destroy$ = new Subject<void>();
  isPreparation = false;
  isCurrentHeadTraining = false;
  completedCount = HEAD_EMPTY_COUNT;
  targetPath = HEAD_EMPTY_ROUTE;
  opening = false;
  readError = false;

  constructor(private adminService: AdminService, private router: Router) {}

  ngOnChanges(): void {
    this.isCurrentHeadTraining = this.notification.messageKey === CURRENT_HEAD_MESSAGE;
    this.isPreparation = this.notification.headNotificationType === HEAD_PREPARATION_TYPE;
    const trainings = this.notification.trainings || [];
    this.completedCount = trainings.filter(training => training.completedLevel >= training.requiredLevel).length;
    this.targetPath = this.isPreparation ? HEAD_LEARNING_ROUTE : this.notification.groupId
      ? HEAD_GROUP_ROUTE + encodeURIComponent(this.notification.groupId) : HEAD_EMPTY_ROUTE;
  }

  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  open(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.targetPath || this.opening) { return; }
    if (this.isPreparation && !this.notification.actionResolved || this.notification.viewed) {
      this.router.navigateByUrl(this.targetPath);
      return;
    }
    this.opening = true;
    this.readError = false;
    this.adminService.notifyIsView({id: this.notification.id, notificationCategory: HEAD_NOTIFICATION_CATEGORY})
      .takeUntil(this.destroy$).subscribe(() => {
        this.opening = false;
        this.notification.viewed = true;
        this.router.navigateByUrl(this.targetPath);
      }, () => { this.opening = false; this.readError = true; });
  }

  trackTraining(index: number, training: HeadTraining): string { return training.specializationId; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/head-notification/head-notification.component.ts